// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__ak0uE","modal_header":"modal_modal_header__aKsDz"};